import { alpha } from "@mui/material/styles";

export default function Modal(theme) {
	return {
		MuiModal: {
			styleOverrides: {
				root: {
					".MuiModal-backdrop": {
						backgroundColor: alpha(theme.palette.grey[1100], 0.8),
					},
				},
			},
		},
	};
}
